// extracted by mini-css-extract-plugin
module.exports = {"amount":"styles_amount__cndnV","three-cols-grid":"styles_three-cols-grid__3_ap7"};